<div class="no-data">
  <svg-icon [src]="assetService.getAssetPath('images/no_data.svg')" />
  <p class="text-center mt-3">
    {{ text ? text : ("ENERGY_COCKPIT.NO_DATA.TEXT" | translate) }}
  </p>
</div>
